module.exports = __webpack_public_path__ + "img/loyalty-banner.5fb08ad0.png";